<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-11 15:00:18
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-09 12:17:16
 * @FilePath:
 * @Description: 点击扫码(取号、点单等)之后自动跳转到该页面，执行取号操作
-->
<template>
  <div></div>
</template>

<script>
import {
  getScanTakeNumber,
  getScanCardBinderInfo,
  getScanTakeNumberInfo,
} from "@/api/scan";
import { handleSessionStorage } from "@/utils";
import { Dialog } from "vant";
export default {
  name: "TakeNumberResult",
  props: {},
  data() {
    return {
      fromPage: "",
    };
  },
  components: {},
  beforeRouteEnter(to, from, next) {
    //在next中写处理函数
    next((vm) => {
      vm.fromPage = from.name;
    });
  },
  created() {
    this.$toast("数据加载中...");
    var pageQuery = this.$route.query;
    const actionQuery = pageQuery.action;
    if (!actionQuery) {
      //扫码取号 key/apply
      this.uuid = pageQuery.uuid;
      this.vpnCode = pageQuery.vpncode;
      // if (this.vpnCode) this.handleSetVpnInfo();
      this.handleSetScanResult();
    } else if (actionQuery == "takeorder") {
      //扫码点餐
      // this.vcQuery = pageQuery.vc;
      this.pQuery = pageQuery.p;
      if (this.pQuery) {
        //手牌绑定器
        this.$nextTick(() => {
          //扫手牌绑定器，进行点单操作
          this.handleGetDeskInfo("handcard");
        });
      } else {
        //普通桌台码

        this.diningRoomId = pageQuery.diningRoomId;
        handleSessionStorage.set("diningRoomId", this.diningRoomId);
        this.deskInfoObj = {
          saasCode: pageQuery.vpncode,
          // depart: pageQuery.departid,
          deskCode: pageQuery.tablecode,
        };
        const _this = this;
        getScanTakeNumberInfo({ vpnCode: pageQuery.vpncode })
          .then((res) => {
            if (typeof res == "string") {
              //未绑定手牌的逻辑
              handleSessionStorage.set("deskCode", {
                code: this.deskInfoObj.deskCode,
                // depart: this.deskInfoObj.depart,
              });
              // handleToPoint();
              this.$nextTick(() => {
                this.handleGetDeskInfo("desk");
              });
            } else {
              //已绑定手牌的逻辑
              const checkinId = res.CheckinId;
              const cardCode = res.TableCode; //手牌号

              handleSessionStorage.set("deskCode", {
                code: this.deskInfoObj.deskCode, //桌号
                // depart: this.deskInfoObj.depart,
                checkinId,
                cardCode,
              });
              // handleToPoint();
              this.$nextTick(() => {
                this.handleGetDeskInfo("desk");
              });
            }
          })
          .catch((err) => {
            handleSessionStorage.set("deskCode", {
              code: this.deskInfoObj.deskCode,
              // depart: this.deskInfoObj.depart,
            });
            // handleToPoint();
            this.$nextTick(() => {
              this.handleGetDeskInfo("desk");
            });
          });
        // function handleToPoint() {
        //   handleSessionStorage.set("isSureVpn", true);
        //   if (_this.$store.state.order.orderPeople) {
        //     //已选人数 再次进入
        //     _this.$router.replace({
        //       name: "Micropoint",
        //       query: { saasCode },
        //     });
        //   } else {
        //     // fromPage用于判断输入人数后 跳转到哪个页面；saasCode用于先扫码后点餐时进入到Micropoint页面时，选中餐台码对应的门店
        //     // isFromMicropoint用于在输入人数页的文案展示区分
        //     _this.$router.replace({
        //       name: "InputPeopleNum",
        //       query: {
        //         fromPage: "Micropoint",
        //         isFromMicropoint: false,
        //         saasCode: saasCode,
        //       },
        //     });
        //   }
        // }
      }
    }
  },
  mounted() {},
  methods: {
    // handleSetVpnInfo() {
    //   const allVpnList = JSON.parse(localStorage.getItem("allStoreList"));

    //   const vpnItem = allVpnList.find((v) => {
    //     return v.SaaSCode === this.vpnCode;
    //   });
    //   if (vpnItem) {
    //     console.log("重新设置vpn");
    //     this.$store.commit("set_vpnid", vpnItem.Id);
    //     this.$store.commit("set_vpnInfo", {
    //       name: vpnItem.Name,
    //       code: vpnItem.SaaSCode,
    //       // payType: vpnItem.payType,
    //       Claims: vpnItem.Claims,
    //       ...vpnItem.SaasVpnSetting,
    //     });
    //   }
    // },
    handleSetScanResult() {
      getScanTakeNumber({
        BindingUuid: this.uuid,
        VpnCode: this.vpnCode,
      })
        .then((res) => {
          this.$router.push({ name: "ConsumeCodeInfo" });
        })
        .catch((err) => {
          if (err.message.indexOf("您已绑定手牌") != -1) {
            this.$router.push({ name: "ConsumeCodeInfo" });
          }
        });
    },
    handleGetDeskInfo(flag) {
      // 如果this.fromPage == "Micropoint" 表示先点餐后扫餐台码的情况，此时扫完码需要跳转到订单提交页
      const pageUrl =
        this.fromPage == "Micropoint" ? "NewPlaceOrder" : "Micropoint";
      // 此时确认唯一门店，用于在进入点单页之后决定能否切换门店
      if (this.fromPage !== "Micropoint") {
        handleSessionStorage.set("isSureVpn", true);
      }
      const vpnInfo = handleSessionStorage.get("vpnInfo");
      getScanCardBinderInfo({
        OnlyGetBindingInfo: flag !== "handcard",
        TableArea: flag !== "handcard" ? this.deskInfoObj.deskCode : null,
        SaasVpnCode:
          this.fromPage == "Micropoint" && vpnInfo
            ? vpnInfo.code
            : flag !== "handcard"
            ? this.deskInfoObj.saasCode
            : null,
        QrCodeParaText: flag == "handcard" ? this.pQuery : null,
      }).then((res) => {
        console.log(this.fromPage);
        // 当选餐门店与桌码门店不一致，弹窗提示
        if (res.NoticeInfo) {
          return this.handleShowModal(res.SaasVpnCode);
        }
        if (flag == "handcard") {
          const deskCode = res.TableArea;
          const depart = res.DepartId;
          const checkinId = res.CheckinId;
          const cardCode = res.TableCode;
          if (deskCode) {
            handleSessionStorage.set("deskCode", {
              code: deskCode,
              depart,
              checkinId,
              cardCode,
            });
          }
        }
        handleSessionStorage.set("teamId", res.Team ? res.Team.Id : null);
        // this.$store.commit("set_deskcode", { code: deskCode, depart });

        if (res.HasGroupOrder) {
          //有订单则跳转到点单记录页
          this.$router.push({
            name: "RecordsConsumption",
          });
        } else if (res.Team && res.Team.PersonNum != 0) {
          // 团队点餐直接赋值之前选择的人数，进入点餐页
          this.$store.dispatch("order/SET_ORDER_PEOPLE", res.Team.PersonNum);
          //已选人数 再次进入
          this.$router.replace({
            name: pageUrl,
            query: {
              saasCode: res.SaasVpnCode,
              diningRoomId: this.diningRoomId,
            },
          });
        } else {
          if (this.$store.state.order.orderPeople) {
            // 非团队点餐，将之前选择人数清空，进入选择人数页
            this.$store.dispatch("order/SET_ORDER_PEOPLE", null);
          }
          // fromPage用于判断输入人数后 跳转到哪个页面；saasCode用于先扫码后点餐时进入到Micropoint页面时，选中餐台码对应的门店
          // isFromMicropoint用于在输入人数页的文案展示区分
          this.$router.replace({
            name: "InputPeopleNum",
            query: {
              fromPage: pageUrl,
              isFromMicropoint: this.fromPage == "Micropoint",
              saasCode: res.SaasVpnCode,
              diningRoomId: this.diningRoomId,
            },
          });
        }
      });
    },
    handleShowModal(code) {
      Dialog.confirm({
        message:
          "选餐门店与桌码门店不一致，是否切换到桌码门店？\n\n提示：切换门店后需重新点餐",
        messageAlign: "left",
        confirmButtonText: "切换门店",
      })
        .then(() => {
          // on confirm
          this.handleBindDesk(code);
        })
        .catch(() => {
          // on cancel
          this.$router.replace({
            name: "Micropoint",
          });
        });
    },
    handleBindDesk(saasCode) {
      //key/binder
      getScanCardBinderInfo({
        SaasVpnCode: saasCode,
        QrCodeParaText: this.pQuery,
      }).then((res) => {
        const deskCode = res.TableArea;
        const depart = res.DepartId;
        const checkinId = res.CheckinId;
        const cardCode = res.TableCode;
        if (deskCode) {
          handleSessionStorage.set("deskCode", {
            code: deskCode,
            depart,
            checkinId,
            cardCode,
          });
        }
        // this.$store.commit("set_deskcode", { code: deskCode, depart });
        this.$router.replace({
          name: "Micropoint",
          query: { saasCode },
        });
      });
    },
  },
};
</script>
<style scoped lang="scss"></style>
